/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import Vue from 'vue';
import CgTabs from '@/components/CgTabs';
import NumberInput from '@/components/Editors/Number';
import PromiseLoader from '@/components/PromiseLoader';
// @ts-expect-error: This component is not in typescript yet.
import SubmitButton from '@/components/SubmitButton';
// This module also imports the store, which imports the entire API, which makes
// mocking it extremely hard.
import User from '@/components/User';
Vue.component('cg-user', User);
Vue.component('cg-submit-button', SubmitButton);
Vue.component('cg-number-input', NumberInput);
Vue.component('cg-promise-loader', PromiseLoader);
Vue.component('cg-tabs', CgTabs);
Vue.component('b-tabs', CgTabs);
